import React, { useState, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { baseurl } from "../utility/helper";
import Swal from "sweetalert2";

const EmailSetting = () => {
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");

  const templates = ["Renewal Member", "Test Pass", "Test Fail", "Prior Evidence Pass", "Prior Evidence Fail", "Reminder", "TestRegistration", "Joining"];

  // Fetch template from backend whenever selectedTemplate changes
  useEffect(() => {
    axios.get(`${baseurl}/admin/setting/get-email-template?name=${selectedTemplate}`)
      .then((res) => {
        setSubject(res.data.subject);
        setBody(res.data.body);
      })
      .catch((err) => {
        if (err.response && err.response.status === 404) {
          // Show toast notification for "Template not found"
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'info',
            title: 'Template not found. You can create it.',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true
          });
          // Keep fields empty so user can create the template
          setSubject('');
          setBody('');
        } else {
          console.error(err);
        }
      });
  }, [selectedTemplate]);

  // Update template in DB
const handleUpdateTemplate = async () => {
  try {
    const res = await axios.post(`${baseurl}/admin/setting/update-email-template`, {
      templateName: selectedTemplate,
      subject,
      body
    });
    alert(res.data.message);
  } catch (err) {
    console.error(err);
    alert("Error updating template");
  }
};


  return (
    <div className="container mt-4">
      <div className="profile-section">
        <div style={{ maxWidth: "800px", margin: "auto", padding: "20px" }}>
          <h2>Edit Email Templates</h2>

          <label>Select Template:</label>
          <select
            value={selectedTemplate}
            onChange={(e) => setSelectedTemplate(e.target.value)}
            style={{ width: "100%", marginBottom: "20px", padding: "8px" }}
          >
              <option value="" disabled>
                -- Select a Template --
              </option>
            {templates.map((template) => (
              <option key={template} value={template}>{template}</option>
            ))}
          </select>

          <label>Subject:</label>
          <input
            type="text"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            style={{ width: "100%", marginBottom: "20px", padding: "8px" }}
          />
          
          <label>Email Body:</label>
          {selectedTemplate !== "Renewal Member" ? (
            <p style={{ color: "red" }}>
              Note: - Dear{" "}
              <span style={{ fontWeight: "bold", color: "red" }}>
                ${"{candidateName}"}
              </span>{" "}
              not remove this.
            </p>
          ) : (
            <p style={{ color: "red" }}>
              Note: - Dear{" "}
              <span style={{ fontWeight: "bold", color: "red" }}>
                ${"{memberName}"}
              </span>{" "}
              not remove this.
            </p>
          )}

          <ReactQuill
            theme="snow"
            value={body}
            onChange={setBody}
            style={{ height: "400px", marginBottom: "20px" }}
          />
          <br />
          <br />
          <center>
          <button
            onClick={handleUpdateTemplate}
            style={{
              padding: "10px 20px",
              backgroundColor: "#B22222",
              color: "#fff",
              border: "none",
              borderRadius: "5px"
            }}
          >
            Save Template
          </button>
          </center>
        </div>
      </div>
    </div>
  );
};

export default EmailSetting;
